/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppapproDTO,
  AppapproStatisticsDTO,
  GetAllLoansParams,
  GetApprovedLoansParams,
  GetLoanStatisticsParams,
  GetLoansByCustomerParams,
  GetPendingLoansParams,
  PageAppapproDTO,
  SearchLoansParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Retrieves loan applications with comprehensive filtering options
 * @summary Get all loan applications with filtering
 */
export const getAllLoans = (
    params: GetAllLoansParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageAppapproDTO>(
      {url: `/api/appappro`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllLoansInfiniteQueryKey = (params?: GetAllLoansParams,) => {
    return [
    'infinite', `/api/appappro`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAllLoansQueryKey = (params?: GetAllLoansParams,) => {
    return [
    `/api/appappro`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllLoansInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllLoans>>>, TError = unknown>(params: GetAllLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLoansInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLoans>>> = ({ signal }) => getAllLoans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllLoansInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLoans>>>
export type GetAllLoansInfiniteQueryError = unknown


export function useGetAllLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLoans>>>, TError = unknown>(
 params: GetAllLoansParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLoans>>,
          TError,
          Awaited<ReturnType<typeof getAllLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLoans>>>, TError = unknown>(
 params: GetAllLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLoans>>,
          TError,
          Awaited<ReturnType<typeof getAllLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLoans>>>, TError = unknown>(
 params: GetAllLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all loan applications with filtering
 */

export function useGetAllLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLoans>>>, TError = unknown>(
 params: GetAllLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllLoansInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllLoansQueryOptions = <TData = Awaited<ReturnType<typeof getAllLoans>>, TError = unknown>(params: GetAllLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLoansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLoans>>> = ({ signal }) => getAllLoans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllLoansQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLoans>>>
export type GetAllLoansQueryError = unknown


export function useGetAllLoans<TData = Awaited<ReturnType<typeof getAllLoans>>, TError = unknown>(
 params: GetAllLoansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLoans>>,
          TError,
          Awaited<ReturnType<typeof getAllLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLoans<TData = Awaited<ReturnType<typeof getAllLoans>>, TError = unknown>(
 params: GetAllLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLoans>>,
          TError,
          Awaited<ReturnType<typeof getAllLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLoans<TData = Awaited<ReturnType<typeof getAllLoans>>, TError = unknown>(
 params: GetAllLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all loan applications with filtering
 */

export function useGetAllLoans<TData = Awaited<ReturnType<typeof getAllLoans>>, TError = unknown>(
 params: GetAllLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllLoansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves a single loan application with detailed information by loan ID
 * @summary Get loan application by ID
 */
export const getLoanById = (
    loanId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppapproDTO>(
      {url: `/api/appappro/${loanId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoanByIdInfiniteQueryKey = (loanId?: string,) => {
    return [
    'infinite', `/api/appappro/${loanId}`
    ] as const;
    }

export const getGetLoanByIdQueryKey = (loanId?: string,) => {
    return [
    `/api/appappro/${loanId}`
    ] as const;
    }

    
export const getGetLoanByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanById>>>, TError = unknown>(loanId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanByIdInfiniteQueryKey(loanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanById>>> = ({ signal }) => getLoanById(loanId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(loanId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanById>>>
export type GetLoanByIdInfiniteQueryError = unknown


export function useGetLoanByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanById>>>, TError = unknown>(
 loanId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanById>>,
          TError,
          Awaited<ReturnType<typeof getLoanById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanById>>>, TError = unknown>(
 loanId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanById>>,
          TError,
          Awaited<ReturnType<typeof getLoanById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanById>>>, TError = unknown>(
 loanId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan application by ID
 */

export function useGetLoanByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanById>>>, TError = unknown>(
 loanId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanByIdInfiniteQueryOptions(loanId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanByIdQueryOptions = <TData = Awaited<ReturnType<typeof getLoanById>>, TError = unknown>(loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanByIdQueryKey(loanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanById>>> = ({ signal }) => getLoanById(loanId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(loanId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanById>>>
export type GetLoanByIdQueryError = unknown


export function useGetLoanById<TData = Awaited<ReturnType<typeof getLoanById>>, TError = unknown>(
 loanId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanById>>,
          TError,
          Awaited<ReturnType<typeof getLoanById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanById<TData = Awaited<ReturnType<typeof getLoanById>>, TError = unknown>(
 loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanById>>,
          TError,
          Awaited<ReturnType<typeof getLoanById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanById<TData = Awaited<ReturnType<typeof getLoanById>>, TError = unknown>(
 loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan application by ID
 */

export function useGetLoanById<TData = Awaited<ReturnType<typeof getLoanById>>, TError = unknown>(
 loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanByIdQueryOptions(loanId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves statistical information about loan applications
 * @summary Get loan application statistics
 */
export const getLoanStatistics = (
    params?: GetLoanStatisticsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppapproStatisticsDTO>(
      {url: `/api/appappro/statistics`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetLoanStatisticsInfiniteQueryKey = (params?: GetLoanStatisticsParams,) => {
    return [
    'infinite', `/api/appappro/statistics`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetLoanStatisticsQueryKey = (params?: GetLoanStatisticsParams,) => {
    return [
    `/api/appappro/statistics`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanStatisticsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanStatistics>>>, TError = unknown>(params?: GetLoanStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanStatisticsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanStatistics>>> = ({ signal }) => getLoanStatistics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanStatisticsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanStatistics>>>
export type GetLoanStatisticsInfiniteQueryError = unknown


export function useGetLoanStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanStatistics>>>, TError = unknown>(
 params: undefined |  GetLoanStatisticsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanStatistics>>,
          TError,
          Awaited<ReturnType<typeof getLoanStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanStatistics>>>, TError = unknown>(
 params?: GetLoanStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanStatistics>>,
          TError,
          Awaited<ReturnType<typeof getLoanStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanStatistics>>>, TError = unknown>(
 params?: GetLoanStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan application statistics
 */

export function useGetLoanStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanStatistics>>>, TError = unknown>(
 params?: GetLoanStatisticsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanStatisticsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanStatistics>>, TError = unknown>(params?: GetLoanStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanStatisticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanStatistics>>> = ({ signal }) => getLoanStatistics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanStatistics>>>
export type GetLoanStatisticsQueryError = unknown


export function useGetLoanStatistics<TData = Awaited<ReturnType<typeof getLoanStatistics>>, TError = unknown>(
 params: undefined |  GetLoanStatisticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanStatistics>>,
          TError,
          Awaited<ReturnType<typeof getLoanStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanStatistics<TData = Awaited<ReturnType<typeof getLoanStatistics>>, TError = unknown>(
 params?: GetLoanStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanStatistics>>,
          TError,
          Awaited<ReturnType<typeof getLoanStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanStatistics<TData = Awaited<ReturnType<typeof getLoanStatistics>>, TError = unknown>(
 params?: GetLoanStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan application statistics
 */

export function useGetLoanStatistics<TData = Awaited<ReturnType<typeof getLoanStatistics>>, TError = unknown>(
 params?: GetLoanStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanStatisticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Provides flexible search across multiple fields
 * @summary Advanced search for loan applications
 */
export const searchLoans = (
    params: SearchLoansParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageAppapproDTO>(
      {url: `/api/appappro/search`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchLoansInfiniteQueryKey = (params?: SearchLoansParams,) => {
    return [
    'infinite', `/api/appappro/search`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchLoansQueryKey = (params?: SearchLoansParams,) => {
    return [
    `/api/appappro/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchLoansInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchLoans>>>, TError = unknown>(params: SearchLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchLoansInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLoans>>> = ({ signal }) => searchLoans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchLoansInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchLoans>>>
export type SearchLoansInfiniteQueryError = unknown


export function useSearchLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchLoans>>>, TError = unknown>(
 params: SearchLoansParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLoans>>,
          TError,
          Awaited<ReturnType<typeof searchLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchLoans>>>, TError = unknown>(
 params: SearchLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLoans>>,
          TError,
          Awaited<ReturnType<typeof searchLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchLoans>>>, TError = unknown>(
 params: SearchLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Advanced search for loan applications
 */

export function useSearchLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchLoans>>>, TError = unknown>(
 params: SearchLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchLoansInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchLoansQueryOptions = <TData = Awaited<ReturnType<typeof searchLoans>>, TError = unknown>(params: SearchLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchLoansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLoans>>> = ({ signal }) => searchLoans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchLoansQueryResult = NonNullable<Awaited<ReturnType<typeof searchLoans>>>
export type SearchLoansQueryError = unknown


export function useSearchLoans<TData = Awaited<ReturnType<typeof searchLoans>>, TError = unknown>(
 params: SearchLoansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLoans>>,
          TError,
          Awaited<ReturnType<typeof searchLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLoans<TData = Awaited<ReturnType<typeof searchLoans>>, TError = unknown>(
 params: SearchLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLoans>>,
          TError,
          Awaited<ReturnType<typeof searchLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLoans<TData = Awaited<ReturnType<typeof searchLoans>>, TError = unknown>(
 params: SearchLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Advanced search for loan applications
 */

export function useSearchLoans<TData = Awaited<ReturnType<typeof searchLoans>>, TError = unknown>(
 params: SearchLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchLoansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves loan applications that are neither approved nor rejected
 * @summary Get pending loan applications
 */
export const getPendingLoans = (
    params: GetPendingLoansParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageAppapproDTO>(
      {url: `/api/appappro/pending`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPendingLoansInfiniteQueryKey = (params?: GetPendingLoansParams,) => {
    return [
    'infinite', `/api/appappro/pending`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPendingLoansQueryKey = (params?: GetPendingLoansParams,) => {
    return [
    `/api/appappro/pending`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPendingLoansInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPendingLoans>>>, TError = unknown>(params: GetPendingLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingLoansInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingLoans>>> = ({ signal }) => getPendingLoans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingLoansInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingLoans>>>
export type GetPendingLoansInfiniteQueryError = unknown


export function useGetPendingLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingLoans>>>, TError = unknown>(
 params: GetPendingLoansParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingLoans>>,
          TError,
          Awaited<ReturnType<typeof getPendingLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingLoans>>>, TError = unknown>(
 params: GetPendingLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingLoans>>,
          TError,
          Awaited<ReturnType<typeof getPendingLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingLoans>>>, TError = unknown>(
 params: GetPendingLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending loan applications
 */

export function useGetPendingLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingLoans>>>, TError = unknown>(
 params: GetPendingLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingLoansInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPendingLoansQueryOptions = <TData = Awaited<ReturnType<typeof getPendingLoans>>, TError = unknown>(params: GetPendingLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingLoansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingLoans>>> = ({ signal }) => getPendingLoans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingLoansQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingLoans>>>
export type GetPendingLoansQueryError = unknown


export function useGetPendingLoans<TData = Awaited<ReturnType<typeof getPendingLoans>>, TError = unknown>(
 params: GetPendingLoansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingLoans>>,
          TError,
          Awaited<ReturnType<typeof getPendingLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingLoans<TData = Awaited<ReturnType<typeof getPendingLoans>>, TError = unknown>(
 params: GetPendingLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingLoans>>,
          TError,
          Awaited<ReturnType<typeof getPendingLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingLoans<TData = Awaited<ReturnType<typeof getPendingLoans>>, TError = unknown>(
 params: GetPendingLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending loan applications
 */

export function useGetPendingLoans<TData = Awaited<ReturnType<typeof getPendingLoans>>, TError = unknown>(
 params: GetPendingLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingLoansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves all loan applications for a specific customer
 * @summary Get loan applications by customer
 */
export const getLoansByCustomer = (
    branch: string,
    custNo: string,
    params: GetLoansByCustomerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageAppapproDTO>(
      {url: `/api/appappro/customer/${branch}/${custNo}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetLoansByCustomerInfiniteQueryKey = (branch?: string,
    custNo?: string,
    params?: GetLoansByCustomerParams,) => {
    return [
    'infinite', `/api/appappro/customer/${branch}/${custNo}`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetLoansByCustomerQueryKey = (branch?: string,
    custNo?: string,
    params?: GetLoansByCustomerParams,) => {
    return [
    `/api/appappro/customer/${branch}/${custNo}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoansByCustomerInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoansByCustomer>>>, TError = unknown>(branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoansByCustomerInfiniteQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoansByCustomer>>> = ({ signal }) => getLoansByCustomer(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoansByCustomerInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoansByCustomer>>>
export type GetLoansByCustomerInfiniteQueryError = unknown


export function useGetLoansByCustomerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoansByCustomer>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansByCustomer>>,
          TError,
          Awaited<ReturnType<typeof getLoansByCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansByCustomerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoansByCustomer>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansByCustomer>>,
          TError,
          Awaited<ReturnType<typeof getLoansByCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansByCustomerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoansByCustomer>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan applications by customer
 */

export function useGetLoansByCustomerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoansByCustomer>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoansByCustomerInfiniteQueryOptions(branch,custNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoansByCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getLoansByCustomer>>, TError = unknown>(branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoansByCustomerQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoansByCustomer>>> = ({ signal }) => getLoansByCustomer(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoansByCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getLoansByCustomer>>>
export type GetLoansByCustomerQueryError = unknown


export function useGetLoansByCustomer<TData = Awaited<ReturnType<typeof getLoansByCustomer>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansByCustomer>>,
          TError,
          Awaited<ReturnType<typeof getLoansByCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansByCustomer<TData = Awaited<ReturnType<typeof getLoansByCustomer>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansByCustomer>>,
          TError,
          Awaited<ReturnType<typeof getLoansByCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansByCustomer<TData = Awaited<ReturnType<typeof getLoansByCustomer>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan applications by customer
 */

export function useGetLoansByCustomer<TData = Awaited<ReturnType<typeof getLoansByCustomer>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetLoansByCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansByCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoansByCustomerQueryOptions(branch,custNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves approved loan applications with customer and product details
 * @summary Get approved loans with detailed information
 */
export const getApprovedLoans = (
    params: GetApprovedLoansParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageAppapproDTO>(
      {url: `/api/appappro/approved`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetApprovedLoansInfiniteQueryKey = (params?: GetApprovedLoansParams,) => {
    return [
    'infinite', `/api/appappro/approved`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetApprovedLoansQueryKey = (params?: GetApprovedLoansParams,) => {
    return [
    `/api/appappro/approved`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApprovedLoansInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApprovedLoans>>>, TError = unknown>(params: GetApprovedLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovedLoansInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovedLoans>>> = ({ signal }) => getApprovedLoans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApprovedLoansInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovedLoans>>>
export type GetApprovedLoansInfiniteQueryError = unknown


export function useGetApprovedLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovedLoans>>>, TError = unknown>(
 params: GetApprovedLoansParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedLoans>>,
          TError,
          Awaited<ReturnType<typeof getApprovedLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApprovedLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovedLoans>>>, TError = unknown>(
 params: GetApprovedLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedLoans>>,
          TError,
          Awaited<ReturnType<typeof getApprovedLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApprovedLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovedLoans>>>, TError = unknown>(
 params: GetApprovedLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get approved loans with detailed information
 */

export function useGetApprovedLoansInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApprovedLoans>>>, TError = unknown>(
 params: GetApprovedLoansParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApprovedLoansInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApprovedLoansQueryOptions = <TData = Awaited<ReturnType<typeof getApprovedLoans>>, TError = unknown>(params: GetApprovedLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovedLoansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovedLoans>>> = ({ signal }) => getApprovedLoans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApprovedLoansQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovedLoans>>>
export type GetApprovedLoansQueryError = unknown


export function useGetApprovedLoans<TData = Awaited<ReturnType<typeof getApprovedLoans>>, TError = unknown>(
 params: GetApprovedLoansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedLoans>>,
          TError,
          Awaited<ReturnType<typeof getApprovedLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApprovedLoans<TData = Awaited<ReturnType<typeof getApprovedLoans>>, TError = unknown>(
 params: GetApprovedLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedLoans>>,
          TError,
          Awaited<ReturnType<typeof getApprovedLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApprovedLoans<TData = Awaited<ReturnType<typeof getApprovedLoans>>, TError = unknown>(
 params: GetApprovedLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get approved loans with detailed information
 */

export function useGetApprovedLoans<TData = Awaited<ReturnType<typeof getApprovedLoans>>, TError = unknown>(
 params: GetApprovedLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovedLoans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApprovedLoansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




